import { render, staticRenderFns } from "./DataWalletCreate.vue?vue&type=template&id=76cf7c43&scoped=true&"
import script from "./DataWalletCreate.vue?vue&type=script&lang=js&"
export * from "./DataWalletCreate.vue?vue&type=script&lang=js&"
import style0 from "./DataWalletCreate.vue?vue&type=style&index=0&id=76cf7c43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cf7c43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76cf7c43')) {
      api.createRecord('76cf7c43', component.options)
    } else {
      api.reload('76cf7c43', component.options)
    }
    module.hot.accept("./DataWalletCreate.vue?vue&type=template&id=76cf7c43&scoped=true&", function () {
      api.rerender('76cf7c43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/DataWalletCreate.vue"
export default component.exports